<template>
  <div class="product-card">
    <div class="product-card--overlay"></div>
    <span class="btn-remove" @click="onRemove(product)">&times;</span>
    <span
      class="product-card--liked"
      v-if="isAccepted(product.variantId, preshippingFeedback)"
    >
      <SvgFile name="heart-with-border" size="28" color="#5C7069" />
    </span>
    <span
      class="product-card--check"
      v-if="isProductIn(null, product.variantId, outfitArray)"
      @click="$emit('selectProduct', product)"
    >
      &#10003;
    </span>
    <div class="img-thumbnail" v-lazy-container="{ selector: 'img' }">
      <img
        :data-src="product.thumbnail"
        :alt="product.brand ? product.brand.name : 'Product image'"
        class="product-image"
        @click="$emit('selectProduct', product)"
      />
    </div>
    <div
      class="btn-outfits flex"
      :class="{
        'justify-content-between': numButtonOutfits > 1,
        'justify-center': numButtonOutfits == 1,
      }"
    >
      <div style="width: 100%;">
        <button
          v-for="outfit in numOutfits"
          @click="onAddFit(outfit, product)"
          :key="outfit"
          class="bg-pink btn-sm"
          :class="{
            'product-in': isProductIn(outfit, product.variantId, outfitArray),
          }"
        >
          {{ outfit }}
        </button>
        <button
          v-if="singleOutfits"
          @click="onAddSingleFit(product)"
          class="bg-pink btn-sm"
          :class="{
            'product-in': isSingleProductIn(numOutfits, product.variantId, outfitArray),
          }"
        >
          SI
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'

export default {
  name: 'StyleBox',

  props: [
    'numOutfits',
    'numOutfitsWithSingle',
    'singleOutfits',
    'numButtonOutfits',
    'outfitArray',
    'product',
    'onRemove',
    'onAddFit',
    'onAddSingleFit',
    'preshippingFeedback'
  ],
  data () {
    return {

    }
  },
  computed: {
    singleNum () {
      return this.numOutfits + 1
    },
    outfitsNum () {
      return this.numOutfits
    }
  },
  methods: {
    isProductIn (outfit = null, variantId, outfitArray) {
      if (outfit) {
        if (!outfitArray[outfit]) return false
        return (
          outfitArray[outfit].products.findIndex(
            (el) => el.variantId === variantId
          ) !== -1
        )
      } else {
        let ans = false
        for (const index in outfitArray) {
          ans =
            ans ||
            outfitArray[index].products.findIndex(
              (el) => el.variantId === variantId
            ) !== -1
        }
        return ans
      }
    },
    isSingleProductIn (outfit, variantId, outfitArray) {
      if (!outfitArray[0]) {
        return false
      }
      return (
        outfitArray[0].products.findIndex(
          (el) => el.variantId === variantId
        ) !== -1
      )
    },
    isAccepted (variantId, preshippingFeedback) {
      const feedback = preshippingFeedback.filter((el) => el.variant_id === variantId)
      let accepted = false
      if (feedback.length > 0) {
        accepted = feedback[0].accepted
      }
      return accepted
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../styles/variables.less";

.product-card {
  position: relative;
  width: 25%;
  padding: 10px;
  box-sizing: border-box;

    @media screen and (max-width: 1700px) {
        width: 33%;
    }
    @media screen and (max-width: 1300px) {
        width: 45%;
    }
    @media screen and (max-width: 900px) {
        width: 80%;
    }
  .btn-outfits {
    padding: 5px 10px;
    .btn-sm {
      padding: 5px;
      margin: 2.5%;
      width: 20%;
    }
    .btn-md {
      padding: 10px 15px;
    }

    button.product-in {
      background-color: @dark-grey !important;
    }

    @media screen and (max-width: 1600px) {
      padding: 5px;

      .btn-md {
        padding: 10px 12px !important;
      }
    }
  }
  &--liked {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  &--check {
    position: absolute;
    top: 100px;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #00b050;
    font-size: 100px;
    cursor: pointer;
  }

  &.disabled {
    .product-card--overlay {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #fff;
      opacity: 0.8;
      top: 0;
      left: 0;
      z-index: 10;
    }
  }
  .img-thumbnail {
    width: 100%;
    height: 180px;
  }
  .product-image {
    border: 1px solid #000;
    width: 100%;
    height: 180px;
    // padding: 10px;
    object-fit: contain;
  }

  .btn-remove {
    position: absolute;
    top: 0;
    left: 0;
    width: 25px;
    height: 25px;
    line-height: 25px;
    border-radius: 50%;
    text-align: center;
    cursor: pointer;
    background: #000;
    color: #fff;
    font-weight: 900;

    &:hover {
      background-color: #fff;
      color: #000;
      border: 1px solid #000;
    }
  }
}
</style>
